import React from "react";
import InputMask from "react-input-mask";
import {
  TextField,
  Button,
  Typography,
  MenuItem,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
function LawFirmDetailsStep({
  lawFirmData,
  handleLawFirmChange,
  handleFileChange,
  internalUsers,
}) {
  return (
    <>
      <Grid size={{ xs: 12 }}>
        <TextField
          label="Law Firm Name"
          name="name"
          fullWidth
          required
          variant="outlined"
          value={lawFirmData.name}
          onChange={handleLawFirmChange}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <TextField
          select
          label="Managed By"
          name="managed_by"
          fullWidth
          variant="outlined"
          value={lawFirmData.managed_by || ""}
          onChange={handleLawFirmChange}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {internalUsers.map((user) => (
            <MenuItem
              key={user.internal_user_id}
              value={user.internal_user_id}
            >
              {user.full_name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Button
          variant="contained"
          component="label"
          sx={{ textTransform: "none", marginBottom: 2 }}
        >
          Upload Logo{" "}
          <input
            type="file"
            hidden
            accept="image/*"
            onChange={handleFileChange}
          />
        </Button>
        {lawFirmData.logoName && (
          <Typography variant="body2" sx={{ marginTop: 1 }}>
            {lawFirmData.logoName}...
          </Typography>
        )}
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          label="Website"
          name="website"
          fullWidth
          variant="outlined"
          value={lawFirmData.website}
          onChange={handleLawFirmChange}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          label="Accounting Contact Full Name"
          name="accountingContactName"
          fullWidth
          variant="outlined"
          value={lawFirmData.accountingContactName}
          onChange={handleLawFirmChange}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          label="Accounting Contact Email"
          name="accountingContactEmail"
          type="email"
          fullWidth
          variant="outlined"
          value={lawFirmData.accountingContactEmail}
          onChange={handleLawFirmChange}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <InputMask
          mask="(999) 999-9999"
          value={lawFirmData.accountingContactPhone}
          onChange={handleLawFirmChange}
        >
          {() => (
            <TextField
              label="Accounting Contact Phone"
              name="accountingContactPhone"
              fullWidth
              variant="outlined"
            />
          )}
        </InputMask>
      </Grid>
    </>
  );
}

export default LawFirmDetailsStep;
